import { SvrAPk } from "../../utils/axios";

/**
 * Crear un turno para el servicio
 */
const getRegistrarTurno = async (AreaId, ServicioId, Data) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/turno/getregistrarturnos", {
      AreaId,
      ServicioId,
      Data,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};
export { getRegistrarTurno };
